import styled from 'styled-components';
import FormBase from '../Form/form';
import Modal from '../Modal/modal';

export const Form = styled(FormBase)`
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
  height: 100%;
`;

export const Header = styled.div`
  flex-shrink: 0;
`;

export const Body = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
`;

export const BodyContent = styled.div`
  padding: 1.5rem;
`;

export const Footer = styled(Modal.Footer)`
  flex-shrink: 0;
  margin: 0 !important;
  display: flex;
  justify-content: flex-end;
  padding: 1rem 1.5rem;
  background-color: transparent;
  border-top: 1px solid #e9ecef;
`;
